export const ANNOTATION_LABEL_FONT_WIDTH = 10;
